export default "__VITE_ASSET__CbZFk_3R__"